const latinSearchCharacterMap = {
    "\u00df": "ss",
    "\u00e6": "ae",
    "\u0153": "oe",
    "\u00f0": "d",
    "\u00fe": "th",
    "\u0142": "l",
    "\u0111": "d",
    "\u00f8": "o",
    "\u0131": "i",
};

const mappedLatinSearchCharacters = /[\u00df\u00e6\u0153\u00f0\u00fe\u0142\u0111\u00f8\u0131]/g;

export function normalizeSearchCharacters(search) {
    search = String(search || '').toLowerCase();

    search = search.replace(mappedLatinSearchCharacters, function (character) {
        return latinSearchCharacterMap[character] || character;
    });

    if (typeof search.normalize === "function") {
        search = search.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    return search;
}

export function normalizeForSearch(search) {
    search = normalizeSearchCharacters(search);

    // Remove all spaces e.g. lat pull down, someone might enter pulldown
    search = search.replace(/\s+/g, '');

    // Dumbbell is also spelled dumbell
    search = search.replace(/dumbb/g, 'dumb');

    return search;
}

export function isExerciseMatch(search, exerciseText) {
    const normalizedSearch = normalizeForSearch(search);
    const normalizedExerciseText = normalizeForSearch(exerciseText);
    return normalizedExerciseText.indexOf(normalizedSearch) !== -1;
}